import { render, staticRenderFns } from "./ContinuePreviousWork.vue?vue&type=template&id=6b897b93&scoped=true"
import script from "./ContinuePreviousWork.vue?vue&type=script&lang=js"
export * from "./ContinuePreviousWork.vue?vue&type=script&lang=js"
import style0 from "./ContinuePreviousWork.vue?vue&type=style&index=0&id=6b897b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b897b93",
  null
  
)

export default component.exports